import React from 'react';
import Helmet from "react-helmet";
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {PageLoader} from "../components/Loader";
import _ from "lodash";
//import {config} from "../../config";
import {fetchUrlChatWebcam} from "../../libs/api";


class ChatWebcam extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading : false
        }
        this.iframeRef = React.createRef();
        this.fetchChatWebcam = this.fetchChatWebcam.bind(this);
    }

    fetchChatWebcam(){
        fetchUrlChatWebcam().then(response =>{
            //this.setState({url : response.data.url})
            //let username = encodeURIComponent(this.props.currentUser?.username.toLowerCase());
            //let gender = encodeURIComponent(config.genderList[_.get(this.props.currentUser,"profile.gender") || 0]).toLowerCase();
            //let url = `https://html5-chat.com/script/18352/5e32c28031d3c/${username}/${gender}`;
            if(!this.state.loading){
                this.setState({loading : true})
            }
            let url = response.url;

            let doc = this?.iframeRef?.current?.contentDocument;
            if ( doc ) {
                try {
                    doc.open();
                    doc.write(`<script src="${url}" ></script>`);
                    doc.close();
                }
                catch(error) {
                    console.error('Chat Webcam failed');
                }
            } else {
                console.error('Chat Webcam failed (contentDocument missing)');
            }
        }).catch(e =>{
            console.log(e);
        });
    }
    
    componentDidMount() {
        if(this.state.loading){
            this.setState({loading : false});
        }

        this.fetchChatWebcam();
    }

    render() {
        if(!this.props.currentUserInitialized){
            return (<PageLoader/>);
        }
        if(this.props.currentUserInitialized && !_.get(this.props.currentUser, "customer.subscribed")){
            this.props.history.push("/");
            return (<PageLoader/>);
        }

        return (
            <div id="chat-webcam">
                <Helmet>
                    <title>Voissa - Chat Webcam</title>
                    <meta name="robots" content="noindex,nofollow" />
                    <meta name="prerender-status-code" content="404" />
                </Helmet>
                <style>{"\
                    body{\
                      overflow-y:hidden;\
                    }\
                  "}</style>
                {!this.state.loading ? (<PageLoader/>) : null}
                <iframe title={"chat"} className={"iframe-chat"} ref={this.iframeRef} />
            </div>
        )
    }

};

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({

}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ChatWebcam);